import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { StoreProvider } from './context/StoreContext';
import AuthPage from './components/AuthPage';
import Layout from './components/Layout';
import SectionLayout from './components/SectionLayout';
import { SECTION_LINKS } from './config/navigation';

import Dashboard from './pages/Dashboard';
import Properties from './pages/Properties';
import Tenants from './pages/Tenants';
import Calendar from './pages/Calendar';
import PropertyVisits from './pages/PropertyVisits';
import Financials from './pages/Financials';
import PaymentReminders from './pages/PaymentReminders';
import PaymentHistoryReports from './pages/PaymentHistoryReports';
import UtilitiesTracker from './pages/UtilitiesTracker';
import Maintenance from './pages/Maintenance';
import Onboarding from './pages/Onboarding';
import Communications from './pages/Communications';
import DocumentTemplates from './pages/DocumentTemplates';
import LeaseExpirations from './pages/LeaseExpirations';
import Feedback from './pages/Feedback';
import SecurityLogs from './pages/SecurityLogs';
import Settings from './pages/Settings';

function AppContent() {
  const { session, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-8 h-8 border-3 border-indigo-200 border-t-indigo-600 rounded-full animate-spin" />
      </div>
    );
  }

  if (!session) {
    return <AuthPage />;
  }

  return (
    <StoreProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />

            <Route path="properties" element={<SectionLayout links={SECTION_LINKS.properties} />}>
              <Route index element={<Properties />} />
              <Route path="tenants" element={<Tenants />} />
              <Route path="calendar" element={<Calendar />} />
              <Route path="visits" element={<PropertyVisits />} />
            </Route>

            <Route path="financials" element={<SectionLayout links={SECTION_LINKS.financials} />}>
              <Route index element={<Financials />} />
              <Route path="reminders" element={<PaymentReminders />} />
              <Route path="reports" element={<PaymentHistoryReports />} />
              <Route path="utilities" element={<UtilitiesTracker />} />
            </Route>

            <Route path="operations" element={<SectionLayout links={SECTION_LINKS.operations} />}>
              <Route index element={<Maintenance />} />
              <Route path="onboarding" element={<Onboarding />} />
              <Route path="communications" element={<Communications />} />
              <Route path="templates" element={<DocumentTemplates />} />
              <Route path="expirations" element={<LeaseExpirations />} />
              <Route path="feedback" element={<Feedback />} />
            </Route>

            <Route path="admin" element={<SectionLayout links={SECTION_LINKS.admin} />}>
              <Route index element={<SecurityLogs />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Route>
        </Routes>
      </HashRouter>
    </StoreProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
